module.exports = __webpack_public_path__ + "img/distinctions/image-01@2x.jpg";